
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2to2n", function(module, exports) {
/* ContextualCreateContentPopover.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $lGgRw = parcelRequire("lGgRw");


var $4kfV4 = parcelRequire("4kfV4");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $56QzY = parcelRequire("56QzY");


var $lqy4C = parcelRequire("lqy4C");


var $de2j9 = parcelRequire("de2j9");


var $7xVCs = parcelRequire("7xVCs");


var $luv00 = parcelRequire("luv00");


var $gz8ZY = parcelRequire("gz8ZY");


var $6adZX = parcelRequire("6adZX");


var $cbBHq = parcelRequire("cbBHq");


var $7EIq6 = parcelRequire("7EIq6");


var $6PMed = parcelRequire("6PMed");


var $cDCEW = parcelRequire("cDCEW");

/* TreeCreateContentButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $g5gZt = parcelRequire("g5gZt");


var $eEA8O = parcelRequire("eEA8O");

const $a853228e227f5ed3$var$i18n = (0, $cgtv4.defineMessages)({
    createLabel: {
        id: "create-blank-fabric-page.tree-create-content-button.create-label",
        defaultMessage: "Create"
    },
    createAriaLabelForSpace: {
        id: "create-blank-fabric-page.tree-create-content-button.create-aria-label-for-space",
        defaultMessage: "Create content in this space"
    }
});
const $a853228e227f5ed3$export$ad05072092786bab = ({ triggerProps: triggerProps, onClick: onClick, isSelected: isSelected, href: href })=>{
    const intl = (0, $8C5kA.default)();
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a853228e227f5ed3$var$IconWrapper, {
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
        label: ""
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            height: '36px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            paddingLeft: '10px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            marginLeft: '0px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            alignItems: 'center'
        },
        href: href,
        onClick: onClick,
        isSelected: isSelected,
        testId: "tree-create-content-button",
        "aria-label": intl.formatMessage($a853228e227f5ed3$var$i18n.createAriaLabelForSpace),
        iconBefore: icon,
        appearance: "subtle",
        shouldFitContainer: true,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a853228e227f5ed3$var$TitleWrapper, {
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a853228e227f5ed3$var$i18n.createLabel)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $a853228e227f5ed3$var$IconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazdgkc",
            __cmplp.isSelected && "_syazxl6c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $a853228e227f5ed3$var$TitleWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _syazazsu _k48pi7a9 _18u01b66",
            __cmplp.isSelected && "_syaz6x5g _k48p1pd9",
            __cmplp.className
        ])
    });
});



var $jmjWc = parcelRequire("jmjWc");


const $c577bd07d81ca8a9$export$bcd38c5b8189fb61 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "F0d7H",
    name: "ContextualCreateContentPopoverMenuLoader",
    loader: async ()=>(await (parcelRequire("fSpPx"))).ContextualCreateContentPopoverMenu
});














var $lujnM = parcelRequire("lujnM");


var $iI2ST = parcelRequire("iI2ST");

const $8c3f789353c0f876$var$addIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
    label: "",
    color: "currentColor",
    size: "small"
});
const $8c3f789353c0f876$export$eabe3aa0b599cb62 = ({ onClick: onClick, href: href })=>{
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
        onClick: onClick,
        elemBefore: $8c3f789353c0f876$var$addIcon,
        href: href
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8c3f789353c0f876$var$i18n.create));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iI2ST.ButtonMenuItem), {
        onClick: onClick,
        elemBefore: $8c3f789353c0f876$var$addIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8c3f789353c0f876$var$i18n.create));
};
const $8c3f789353c0f876$var$i18n = (0, $cgtv4.defineMessages)({
    create: {
        id: "create-blank-fabric-page.create-content-menu-item.create",
        defaultMessage: "Create"
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a7a1bff19d06ba1$var$TriggerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_80om73ad",
            __cmplp.className
        ])
    });
});
const $0a7a1bff19d06ba1$var$customPopupContainerStyles = (0, $ecnYn.xcss)({
    zIndex: 'modal',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'radius.small',
    ':focus': {
        outline: 'none'
    }
});
const $0a7a1bff19d06ba1$var$CustomPopupContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, 'data-testid': dataTestId, ...props }, popupRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: dataTestId,
        ...props,
        ref: popupRef,
        xcss: $0a7a1bff19d06ba1$var$customPopupContainerStyles
    }, children));
const $0a7a1bff19d06ba1$export$a659f5fb9e1f688c = [
    0,
    8
];
const $0a7a1bff19d06ba1$export$79699783f82a969e = ({ closeAllHoverPageCards: closeAllHoverPageCards, isContextualCreateFocused: isContextualCreateFocused, setIsContextualCreateFocused: setIsContextualCreateFocused, spaceKey: spaceKey, parentId: parentId, source: source, displayTitle: displayTitle, rootCreateButtonStyling: rootCreateButtonStyling = false, shouldShowPopup: shouldShowPopup, setShouldShowPopup: setShouldShowPopup, isTreeItem: isTreeItem, placement: placement = 'right-start', offset: offset = [
    -10,
    8
], onItemClick: onItemClick, shouldRenderToParent: shouldRenderToParent, hideFolder: hideFolder, contentType: contentType })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(()=>!!shouldShowPopup);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if (isNav4Enabled) {
        placement = 'bottom-start';
        offset = $0a7a1bff19d06ba1$export$a659f5fb9e1f688c;
    }
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'page-tree-contextual-create'
    });
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const preloadCreationMenuData = (0, $6PMed.usePreloadCreationMenuData)();
    const preloadSmartCreationModal = (0, $cbBHq.usePreloadSmartCreationModal)();
    const preloadCreationMenu = ()=>{
        preloadCreationMenuData();
        preloadSmartCreationModal();
        (0, $c577bd07d81ca8a9$export$bcd38c5b8189fb61).preload();
    };
    const stopEvents = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
    }, []);
    const handleOnClick = (0, $42omo.useCallback)((event)=>{
        if (isNav4Enabled) closeFlyout();
        stopEvents(event);
    }, [
        isNav4Enabled,
        stopEvents,
        closeFlyout
    ]);
    const onTriggerClick = (0, $42omo.useCallback)(()=>{
        setIsContextualCreateFocused?.(!isContextualCreateFocused);
        closeAllHoverPageCards?.();
        setIsOpen(!isOpen);
        setShouldShowPopup?.(!isOpen);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'contextualCreateButton',
                actionSubjectId: source,
                source: 'containerNavigation',
                attributes: {
                    navdexPointType: (0, $56QzY.START),
                    isOnEditRoute: isOnEditRoute
                }
            }
        }).fire();
    }, [
        isOpen,
        setIsOpen,
        setShouldShowPopup,
        closeAllHoverPageCards,
        isContextualCreateFocused,
        setIsContextualCreateFocused,
        createAnalyticsEvent,
        source,
        isOnEditRoute
    ]);
    const onCloseHandler = (0, $42omo.useCallback)(()=>{
        // The bluring of the active element should be temporary, see this ticket for an explanation: https://hello.atlassian.net/browse/CCT-906
        const activeEle = document.activeElement; // @ts-ignore
        activeEle?.blur();
        setIsOpen(false);
        setShouldShowPopup?.(false); // This needs to be set after the focus returns to the trigger button
        setTimeout(()=>{
            setIsContextualCreateFocused?.(false);
        }, 0);
    }, [
        setIsOpen,
        setShouldShowPopup,
        setIsContextualCreateFocused
    ]);
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateFolderEnabled: isCreateFolderEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $7xVCs.PageTreeStateUpdater)
        ]
    }, (pageStateUpdater)=>// rendering popup to parent for a11y purposes was causing issues for contextual create on tree items in the page tree
        // so popup is rendered to parent based on whether shouldRenderToParent prop is true
        // TODO: DISCO-2052 resolve this issue and render to parent for all cases
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRenderToParent && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
            testId: "contextual-create-blanket",
            isTinted: false,
            onBlanketClicked: onCloseHandler
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: onCloseHandler,
            placement: placement,
            offset: offset,
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c577bd07d81ca8a9$export$bcd38c5b8189fb61), {
                    source: source,
                    parentId: parentId,
                    isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
                    isCreateDatabaseEnabled: isCreateDatabaseEnabled,
                    isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
                    isCreateLiveDocEnabled: isCreateLiveDocEnabled,
                    isCreateFolderEnabled: isCreateFolderEnabled && !hideFolder,
                    onCloseMenu: onCloseHandler,
                    pageStateUpdater: pageStateUpdater,
                    onItemClick: onItemClick,
                    parentTitle: displayTitle,
                    parentContentType: contentType
                }),
            popupComponent: shouldRenderToParent ? $0a7a1bff19d06ba1$var$CustomPopupContainer : undefined,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a7a1bff19d06ba1$var$TriggerContainer, {
                    onClick: handleOnClick,
                    onFocus: stopEvents,
                    onBlur: stopEvents,
                    "data-vc": "contextual-create-content-popover",
                    ...ssrPlaceholderIdProp
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                    onMouseEnter: preloadCreationMenu,
                    onFocus: preloadCreationMenu
                }, isTreeItem ? isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8c3f789353c0f876$export$eabe3aa0b599cb62), {
                    onClick: enforceStorageLimit(onTriggerClick)
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a853228e227f5ed3$export$ad05072092786bab), {
                    triggerProps: triggerProps,
                    onClick: enforceStorageLimit(onTriggerClick),
                    isSelected: isOpen
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cDCEW.ContextualCreateContentButton), {
                    onClick: enforceStorageLimit(onTriggerClick),
                    triggerProps: triggerProps,
                    isContextualCreateFocused: isContextualCreateFocused,
                    spaceKey: spaceKey,
                    rootCreateButtonStyling: rootCreateButtonStyling,
                    displayTitle: displayTitle
                })), !shouldRenderToParent && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                    testId: "contextual-create-blanket",
                    isTinted: false,
                    onBlanketClicked: onCloseHandler
                })),
            shouldRenderToParent: shouldRenderToParent,
            testId: "contextual-create-popover"
        })));
};
module.exports["NAV4_POPOVER_OFFSET"] = $0a7a1bff19d06ba1$export$a659f5fb9e1f688c;
module.exports["ContextualCreateContentPopover"] = $0a7a1bff19d06ba1$export$79699783f82a969e;

});

parcelRegister("cDCEW", function(module, exports) {
/* ContextualCreateContentButton.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $eSUdr = parcelRequire("eSUdr");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $3gadb = parcelRequire("3gadb");


var $g5gZt = parcelRequire("g5gZt");


var $5izcQ = parcelRequire("5izcQ");


var $lfBMY = parcelRequire("lfBMY");


var $2wo33 = parcelRequire("2wo33");


var $b3j2Y = parcelRequire("b3j2Y");


var $gz8ZY = parcelRequire("gz8ZY");


var $jtuBN = parcelRequire("jtuBN");

const $6e1fd29dfbf932de$var$i18n = (0, $cgtv4.defineMessages)({
    simpleCreateLabel: {
        id: "create-blank-fabric-page.contextual-create.button.simple-create-label",
        defaultMessage: "Create"
    },
    simpleCreateLabelForTitle: {
        id: "create-blank-fabric-page.contextual-create.button.simple-create-label-for-title",
        defaultMessage: "Create child content for {pageTitle}"
    }
});
const $6e1fd29dfbf932de$var$canCreateContent = (data)=>{
    return (0, $2wo33.canPerformSpaceOperation)({
        operationCheckResult: data,
        operation: (0, $lfBMY.OperationTypes).CREATE,
        contentType: 'page'
    });
};
const $6e1fd29dfbf932de$export$e5aab90af54da00f = (isOpen)=>{
    return isOpen ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)";
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-unsafe-style-overrides -- To migrate as part of go/ui-styling-standard
const $6e1fd29dfbf932de$var$ContextualCreateButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $1qfLF.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_147mbvz": (0, $7sObp.default)($6e1fd29dfbf932de$export$e5aab90af54da00f(__cmplp.isOpen))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1efsqup9",
            __cmplp.isRootCreateButton ? "_i2zu1q3r" : "_i2zu1kw7",
            __cmplp.className
        ])
    });
});
const $6e1fd29dfbf932de$export$613f902834bf164 = ({ triggerProps: triggerProps, onClick: onClick, isContextualCreateFocused: isContextualCreateFocused, spaceKey: spaceKey, rootCreateButtonStyling: rootCreateButtonStyling, displayTitle: displayTitle })=>{
    const intl = (0, $8C5kA.default)();
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $eSUdr.default)`query ContextualCreateContentButtonQuery($spaceKey:String!){space(key:$spaceKey){id operations{operation targetType}}}`, {
        variables: {
            spaceKey: spaceKey
        }
    });
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const handleClick = (0, $42omo.useCallback)((e)=>{
        onClick(e);
    }, [
        onClick
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    const canCreate = data && $6e1fd29dfbf932de$var$canCreateContent(data);
    if (loading || !canCreate) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "pagetree-createcontent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6e1fd29dfbf932de$var$i18n.simpleCreateLabel),
        position: "top",
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "enhance-orientation-spotlight-tour-target-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e1fd29dfbf932de$var$ContextualCreateButton, {
        ...triggerProps,
        id: "contextual-create-content-button",
        appearance: "subtle",
        icon: ()=>isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                label: intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabel),
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                label: intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabel)
            }),
        label: displayTitle ? intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabelForTitle, {
            pageTitle: displayTitle
        }) : intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabel),
        onClick: handleClick,
        testId: "contextual-create-content-button",
        isSelected: isContextualCreateFocused,
        isOpen: isContextualCreateFocused,
        isRootCreateButton: rootCreateButtonStyling,
        spacing: "compact"
    }))));
};
module.exports["contextualCreateContentIconSVGColor"] = $6e1fd29dfbf932de$export$e5aab90af54da00f;
module.exports["ContextualCreateContentButton"] = $6e1fd29dfbf932de$export$613f902834bf164;

});

parcelRegister("fSpPx", function(module, exports) {

let $b8efef885677ceee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8efef885677ceee$var$load("gw5jm"),
    $b8efef885677ceee$var$load("6FuHS"),
    $b8efef885677ceee$var$load("eyaRC"),
    $b8efef885677ceee$var$load("dlZSj"),
    $b8efef885677ceee$var$load("6wr18"),
    $b8efef885677ceee$var$load("gMN6Z"),
    $b8efef885677ceee$var$load("aDPqY"),
    $b8efef885677ceee$var$load("c2fNS"),
    $b8efef885677ceee$var$load("7XGoP"),
    $b8efef885677ceee$var$load("dh8Yu"),
    $b8efef885677ceee$var$load("fxPKA"),
    $b8efef885677ceee$var$load("h2QhJ"),
    $b8efef885677ceee$var$load("4eboO"),
    $b8efef885677ceee$var$load("5U3YO"),
    $b8efef885677ceee$var$load("8YSo7"),
    $b8efef885677ceee$var$load("6XCf4"),
    $b8efef885677ceee$var$load("5pvpJ"),
    $b8efef885677ceee$var$load("Wowvf"),
    $b8efef885677ceee$var$load("ffEVr"),
    $b8efef885677ceee$var$load("1qlDN"),
    $b8efef885677ceee$var$load("1yVM6"),
    $b8efef885677ceee$var$load("hhss7"),
    $b8efef885677ceee$var$load("7u4WP"),
    $b8efef885677ceee$var$load("7e13v"),
    $b8efef885677ceee$var$load("let0D"),
    $b8efef885677ceee$var$load("6EQss"),
    $b8efef885677ceee$var$load("bnzpb"),
    $b8efef885677ceee$var$load("7EorR"),
    $b8efef885677ceee$var$load("4Dabn")
]).then(()=>parcelRequire('7yriZ'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});


//# sourceMappingURL=TreeBottomCreateButton.bfff919b.js.map
